/**
 * Shared GraphQL error classification for the audit surfaces.
 *
 * Extracted unchanged from `AuditLogViewer.tsx` (audit-usage-report spec,
 * Requirement 1.6) so the same classifier is shared between `AuditLogViewer`
 * and the upcoming `UsageReportViewer`: when a retrieval fails with an
 * authorization error, each viewer renders only an access-denied message.
 */

/**
 * Classify a thrown GraphQL error as an authorization denial versus a generic
 * retrieval failure. The server-side authorize resolver (the `AuditAuthorizeFn`
 * pipeline step reused by both `getAuditLogs` and `getUsageReport`) denies via
 * `util.unauthorized()`, which surfaces as an `Unauthorized` errorType /
 * "Not Authorized" message on the Amplify error object.
 */
export const isAuthorizationError = (err: unknown): boolean => {
  const anyErr = err as any;
  const matches = (type: unknown, message: unknown): boolean => {
    const t = String(type ?? "").toLowerCase();
    const m = String(message ?? "").toLowerCase();
    return (
      t.includes("unauthorized") ||
      t.includes("forbidden") ||
      m.includes("unauthorized") ||
      m.includes("not authorized") ||
      m.includes("access denied") ||
      m.includes("access is denied")
    );
  };
  if (Array.isArray(anyErr?.errors)) {
    return anyErr.errors.some((e: any) => matches(e?.errorType, e?.message));
  }
  return matches(anyErr?.errorType, anyErr?.message);
};
